"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.whitelistTransform = void 0;
var sets_1 = require("../../utils/lang/sets");
/**
 * Extract whitelist as a set. Used by 'WHITELIST' matcher.
 */
function whitelistTransform(whitelistObject) {
    return new sets_1._Set(whitelistObject.whitelist);
}
exports.whitelistTransform = whitelistTransform;
